var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__field",class:_vm.fixWidth ? '__fix-width' : 'full-width'},[_vm._t("input"),_c('div',{staticClass:"__label",class:_vm.required ? '__required' : ''},[_vm._t("label")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }